import React from 'react';
import { RotateCcw } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export const TrainingMinutesCell = ({ row, context, draft, language, canEdit, disabled, onChange }) => {
  const t = (it, en) => language === 'IT' ? it : en;
  const aid = row.athlete_id;
  if (!context) return <span data-testid={`training-minutes-unavailable-${aid}`}>—</span>;
  if (!context.planner_session_id) return <span data-testid={`training-recorded-minutes-${aid}`}>{row.metrics?.session_minutes ?? '—'}</span>;
  const resolved = context.athletes.find(r => r.athlete_id === aid);
  if (!resolved?.eligible || !context.link_valid) return <span className="text-xs text-zinc-500" data-testid={`training-ineligible-${aid}`}>
    {t('Non eleggibile', 'Not eligible')}
    {draft && Object.prototype.hasOwnProperty.call(draft, 'training_duration_override_min') &&
      <span className="block text-amber-400" data-testid={`training-failed-draft-${aid}`}>
        {t('Bozza non salvata', 'Unsaved draft')}: {draft.training_duration_override_min ?? t('Planner', 'Planner')}
      </span>}
  </span>;
  const edited = draft && Object.prototype.hasOwnProperty.call(draft, 'training_duration_override_min');
  const override = edited ? draft.training_duration_override_min : resolved.override_minutes;
  const value = override == null ? context.planner_duration_min : override;
  const invalid = value === '' || !Number.isSafeInteger(Number(value)) || Number(value) < 0;
  return <div className="flex flex-col gap-1 items-end min-w-0">
    <div className="flex items-center gap-1">
      {canEdit ? <Input type="number" min="0" step="1" aria-label={t('Minuti individuali TRAINING', 'Individual TRAINING minutes')}
        aria-invalid={invalid} disabled={disabled} value={value ?? ''}
        onChange={e => onChange(row.id, e.target.value)}
        className={`w-20 h-8 text-center bg-zinc-950 border-zinc-700 text-zinc-100 font-mono ${edited ? 'ring-1 ring-amber-500/60' : ''}`}
        data-testid={`training-minutes-${aid}`} /> : <span data-testid={`training-minutes-${aid}`}>{value ?? '—'}</span>}
      {canEdit && <Button size="icon" variant="ghost" className="w-8 h-8 shrink-0"
        title={t('Ripristina eredità Planner', 'Reset to Planner inheritance')} aria-label={t('Ripristina eredità Planner', 'Reset to Planner inheritance')}
        disabled={disabled || override == null} onClick={() => onChange(row.id, null)} data-testid={`training-duration-reset-${aid}`}>
        <RotateCcw className="w-3.5 h-3.5" />
      </Button>}
    </div>
    <span className={`text-[10px] text-right ${invalid ? 'text-red-400' : 'text-zinc-400'}`} data-testid={`training-duration-source-${aid}`}>
      {invalid ? t('Minuti non validi', 'Invalid minutes') : override == null ? t('Ereditato dal Planner', 'Inherited from Planner') : t('Override individuale', 'Individual override')}
    </span>
  </div>;
};